import AppUtils from '@/AppUtils';
import { SwalInput } from '@/interfaces/ISwal';
import Swal, { SweetAlertIcon, SweetAlertOptions } from 'sweetalert2';

export default function useSwal() {
    const toast = async (title: string, icon: SweetAlertIcon) => {
        Swal.mixin({
            toast: true,
            position: "top-end",
            backdrop: false,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        }).fire({
            icon: icon,
            title: title,
        });
    }
    const questionWithAnswer = async (customConfig: any | SweetAlertOptions = {}) => {
        let html = '';

        if (customConfig.text) {
            html += `
                <p class="text-left">
                    ${customConfig.text ?? ''}
                </p>
            `;
        }

        if (customConfig.inputType != 'textarea')
            html += `
            <div class="form-group text-left">
                <label class="form-label">${
                    customConfig.inputLabel ? customConfig.inputLabel : ''
                }</label>
                <div class="form-control-wrap">
                    <input type="${
                        customConfig.type
                    }" class="form-control" id="answer-field" placeholder="${
                customConfig.inputPlaceholder
                    ? customConfig.inputPlaceholder
                    : ''
                }"
                        value="${customConfig.value ?? ''}"/>
                </div>
                <p id="answer-validator" class="form-label text-danger m-0 d-none">
                    <span>Este campo es requerido</span>
                </p>
            </div>`;
        else
            html += `
            <div class="form-group text-left">
                <label class="form-label">${
                    customConfig.inputLabel ? customConfig.inputLabel : ''
                }</label>
                <div class="form-control-wrap">
                    <textarea class="form-control" id="answer-field" placeholder="${
                        customConfig.inputPlaceholder
                            ? customConfig.inputPlaceholder
                            : ''
                    }" value="${customConfig.value ?? ''}" >${customConfig.value ?? ''}</textarea>
                </div>
                <p id="answer-validator" class="form-label text-danger m-0 d-none">
                    <span>Este campo es requerido</span>
                </p>
            </div>`;

        const result = await Swal.fire({
            html,
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Aceptar',
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-light',
                header: 'align-items-start',
                content: 'text-left',
            },
            preConfirm: () => {
                const input = document.getElementById(
                    'answer-field'
                ) as HTMLInputElement;
                const errorMessage = document.getElementById(
                    'answer-validator'
                ) as HTMLInputElement;
                if (input.value == '') {
                    errorMessage.classList.remove('d-none');
                    return false;
                } else {
                    errorMessage.classList.add('d-none');
                    return input.value;
                }
            },

            showClass: {
                popup: '',
            },
            hideClass: {
                popup: '',
            },
            buttonsStyling: false,
            ...customConfig,
        });
        return result;
    };

    const questionWithManyAnswers = async (
        inputs: Array<SwalInput>,
        customConfig: SweetAlertOptions = {}
    ) => {
        let html = '';

        if (customConfig.text) {
            html += `
                <p class="text-left">
                    ${customConfig.text}
                </p>
            `;
        }

        inputs.forEach((el: any) => {
            if (el.type != 'textarea')
                html += `
                <div class="form-group text-left">
                    <label class="form-label">${
                        el.label ? el.label : ''
                    }</label>
                    <div class="form-control-wrap">
                        <input type="${el.type}" class="form-control" id="${
                    el.id
                }" placeholder="${
                    el.placeholder ? el.placeholder : ''
                }" value="${el.value ? el.value : ''}"
                    ${ el.money ? "v-maska=\"'#*!.##'\"" : '' }
                    ${ el.max_validation ? "max=\"" + el.max_mount + "\"" : '' }/>
                    </div>
                    <p id="answer-validator-${
                        el.id
                    }" class="form-label text-danger m-0 d-none">
                    </p>
                </div>`;
            else
                html += `
                <div class="form-group text-left">
                    <label class="form-label">${
                        el.label ? el.label : ''
                    }</label>
                    <div class="form-control-wrap">
                        <textarea class="form-control" id="${
                            el.id
                        }" placeholder="${
                    el.placeholder ? el.placeholder : ''
                }" value="${el.value ? el.value : ''}">${el.value ? el.value : ''}</textarea>
                    </div>
                    <p id="answer-validator-${
                        el.id
                    }" class="form-label text-danger m-0 d-none">
                    </p>
                </div>`;
        });

        const result = await Swal.fire({
            html,
            showCancelButton: true,
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-light',
            },
            buttonsStyling: false,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                let hasError = false;
                const values = inputs.reduce((acc: Array<any>, el: any) => {
                    const input = document.getElementById(
                        el.id
                    ) as HTMLInputElement;
                    const errorMessage = document.getElementById(
                        'answer-validator-' + el.id
                    ) as HTMLInputElement;
                    //Vacios
                    if (input.value == '') {
                        errorMessage.innerHTML = 'Este campo no puede estar vacio.';
                        errorMessage.classList.remove('d-none');                        
                        hasError = true;
                    } else {
                        errorMessage.classList.add('d-none');
                    }
                    //Emails
                    if(input.type == 'email'){
                        const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                        if (!input.value.match(validRegex)) {
                            errorMessage.innerHTML = 'Debe ser un correo.';
                            errorMessage.classList.remove('d-none');                        
                            hasError = true;
                        }
                    }
                    //Telefono
                    if(input.type == 'tel'){
                        const validRegex = /^(()?\d{3}())?(-|\s)?\d{3}(-|\s)?\d{4}$/;
                        if (!input.value.match(validRegex)) {                            
                            errorMessage.innerHTML = 'Debe ser un teléfono.';
                            errorMessage.classList.remove('d-none');                        
                            hasError = true;
                        }
                        if (input.value.length <= 9) {                            
                            errorMessage.innerHTML = 'Debe ser un teléfono mayor igual a 10 dígitos.';
                            errorMessage.classList.remove('d-none');                        
                            hasError = true;
                        }
                    }
                    //Max
                    if(input.max){
                        if (Number(input.value) > Number(input.max)) {
                            errorMessage.innerHTML = 'Debe ser menor a ' + input.max + '.';
                            errorMessage.classList.remove('d-none');                        
                            hasError = true;
                        }
                    }
                    acc.push(input?.value);
                    return acc;
                }, []);

                return hasError ? false : [...values];
            },
            showClass: {
                popup: '',
            },
            hideClass: {
                popup: '',
            },
            ...customConfig,
        });
        return result;
    };

    const question = async (
        title: string,
        text: string = '',
        confirmButtonText: string = 'Aceptar',
        cancelButtonText: string = 'Cancelar',
        customButtons: any = null,
        config: SweetAlertOptions = {}
    ) => {
        const result = await Swal.fire({
            title,
            text,
            showCancelButton: true,
            customClass: customButtons
                ? customButtons
                : {
                      confirmButton: 'btn btn-success',
                      cancelButton: 'btn btn-light',
                  },
            buttonsStyling: false,
            confirmButtonText,
            cancelButtonText,
            showClass: {
                popup: '',
            },
            hideClass: {
                popup: '',
            },
            ...config,
        });
        return result;
    };

    const alert = async (config: SweetAlertOptions = {}) => {
        const { getTitleAlert } = AppUtils;
        return await Swal.fire({
            icon: 'success',
            title: getTitleAlert('success'),
            customClass: {
                confirmButton: 'btn btn-success',
            },
            buttonsStyling: false,
            showClass: {
                popup: '',
            },
            hideClass: {
                popup: '',
            },
            ...config,
        });
    };

    return {
        alert,
        question,
        questionWithAnswer,
        questionWithManyAnswers,
        toast
    };
}
